module.exports = __webpack_public_path__ + "static/media/TrustMe_Wide.1e8b3347.png";